// @flow

function debounce (func: Function, wait: number, immediate?: boolean) {
  let timeout

  return function () {
    const context = this
    const args = arguments

    let later = function () {
      timeout = null
      if (!immediate) func.apply(context, args)
    }
    const callNow = immediate && !timeout
    if (timeout) clearTimeout(timeout)
    timeout = setTimeout(later, wait)
    if (callNow) func.apply(context, args)
  }
}

export { debounce }



// WEBPACK FOOTER //
// ./src/lib/debounce.js